import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-beige py-12 md:py-20 px-4" data-id="element-310">
      <div className="max-w-[680px] mx-auto text-center" data-id="element-311">
        <ShieldCheckIcon className="w-16 h-16 text-pink-dark mx-auto mb-6" data-id="element-312" />

        <h2 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray mb-6" data-id="element-313">
          Garantía 7 días: sin riesgo, sin preguntas.
        </h2>

        <div className="font-body text-dark-gray text-base md:text-lg leading-relaxed space-y-2" data-id="element-314">
          <p data-id="element-315">
            Probalo hoy. Si dentro de 7 días sentís que no era para vos, pedí el
            reembolso y listo.
          </p>
          <p data-id="element-316">Compra segura por Shopify. Acceso digital enviado por email.</p>
        </div>
      </div>
    </section>;
}